import { render, staticRenderFns } from "./purchase_request.vue?vue&type=template&id=cb2c9d20&scoped=true"
import script from "./purchase_request.vue?vue&type=script&lang=js"
export * from "./purchase_request.vue?vue&type=script&lang=js"
import style0 from "./purchase_request.vue?vue&type=style&index=0&id=cb2c9d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2c9d20",
  null
  
)

export default component.exports